<template>
  <div class="pa-4 mt-4">
    <h2 class="display-1 pb-4">What kind of context do you want to create?</h2>
    <v-layout wrap>
      <v-col cols="12" class="body-1 pb-0">
        Guided Templates
      </v-col>
      <v-col cols="6" v-for="guide in guides" :key="guide.id" class="pa-1">
        <v-hover v-slot:default="{ hover }">
          <v-card
            flat
            @click="$emit('selectTemplate', guide.id)"
            :color="hover ? 'grey lighten-3' : 'transparent'"
          >
            <v-card-title>
              {{ guide.title }}
            </v-card-title>
            <v-card-text>
              <div class="subtitle">
                {{ guide.description }}
              </div>
              <div v-if="guide.example" class="blue--text">Example: {{ guide.example }}</div>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: ['guides']
};
</script>

<style></style>
